import { PRICING_SUMMARY, UPGRADE_PLAN } from "constants/RouteContants";

export const NO_MENU_ROUTES = [PRICING_SUMMARY, UPGRADE_PLAN];
